import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { Divider } from "@mui/material";
import { useFormikContext } from "formik";
import React from "react";

import MDBox from "@/components/atoms/MDBox";
import MDTypography from "@/components/atoms/MDTypography";
import { SubscribeFormData } from "@/components/templates/SubscribeForm/types";
import useSalesProductPriceData from "@/hooks/data/use-sales-product-price-data";
import { SubscribeMessages } from "@/messages/subscribe/subscribe.messages";

type Props = {
  messages: SubscribeMessages;
};

const Summary = ({ messages }: Props) => {
  const { values } = useFormikContext<SubscribeFormData>();
  const { salesProductPrice } = values;

  const salesProduct = useSalesProductPriceData({ salesProductPrice });

  const showFeePerSalesConvertion = salesProductPrice.feePerSalesConvertion > 0;
  const showFixedFeePerSalesConvertion = salesProductPrice.fixedFeePerSalesConvertion > 0;
  const showPricePerEvent = salesProductPrice.pricePerEvent > 0;

  const addFees = [
    showFeePerSalesConvertion &&
      `${salesProduct.formattedFeePerSalesConvertion} ${messages.feePerOrderText}`,
    showFixedFeePerSalesConvertion &&
      `${salesProduct.formattedFixedFeePerSalesConvertion} ${messages.feePerOrderText}`,
    showPricePerEvent &&
      `${salesProduct.formattedPricePerEvent} ${messages.feePerConversationText}`,
  ].filter(Boolean);

  const feesText = addFees.length > 1 ? messages.additionalFeesLabel : messages.additionalFeeLabel;

  return (
    <>
      <Divider />

      <MDBox display="flex" alignItems={"center"} justifyContent="space-between" mb={0.5}>
        <MDBox display="flex" alignItems={"center"} gap={0.4}>
          <ShoppingCartIcon fontSize="medium" />
          <MDTypography variant="body2" fontWeight="regular">
            {messages.signatureLabel}
          </MDTypography>
        </MDBox>

        <MDBox ml={1}>
          <MDTypography variant="body2" fontWeight="medium">
            {salesProduct.formattedFixedMonthlyFee}
          </MDTypography>
        </MDBox>
      </MDBox>

      {addFees.length > 0 && (
        <MDBox display="flex" alignItems={"center"} justifyContent="space-between" mb={0.5}>
          <MDBox display="flex" alignItems={"center"} gap={0.4}>
            <MonetizationOnIcon fontSize="medium" />
            <MDTypography variant="body2" fontWeight="regular">
              {feesText}
            </MDTypography>
          </MDBox>

          <MDBox ml={1}>
            <MDTypography textAlign={"right"} variant="body2" fontWeight="medium">
              {addFees.map((fee, index) => (
                <span key={index}>
                  {fee}
                  <br />
                </span>
              ))}
            </MDTypography>
          </MDBox>
        </MDBox>
      )}

      <Divider />

      <MDBox display="flex" alignItems={"center"} justifyContent="space-between" mt={3}>
        <MDBox display="flex" alignItems={"center"} gap={0.4}>
          <ShoppingCartIcon fontSize="medium" />
          <MDTypography variant="body1" fontWeight="light">
            {messages.totalLabel}
          </MDTypography>
        </MDBox>

        <MDBox ml={1}>
          <MDTypography variant="body1" fontWeight="medium">
            {salesProduct.formattedFixedMonthlyFee}
          </MDTypography>
        </MDBox>
      </MDBox>
    </>
  );
};

export default Summary;
